import Select from "react-select";
import DatePicker, { registerLocale } from "react-datepicker";
import { toast } from "react-toastify";
import enGb from "date-fns/locale/en-GB";
import FileDownload from "js-file-download";
import { useState } from "react";
import {
  getMyTimeSheetDetails,
  getTimeSheetByWeek,
  downloadCustomerReport,
  downloadAllReport,
} from "../API";
import { getWeekNumber } from "../utils/utils";
import Loader from "../pages/Loader";
import "../assets/styles/report-pages.scss";
registerLocale("en-gb", enGb);

const CustomerReport = () => {
  const [selectedWeek, setSelectedWeek] = useState(null);
  const [allReportWeek, setAllReportWeek] = useState(null);
  const [selectedUserRows, setSelectedUserRows] = useState([]);
  const [selectedEuipmentRows, setSelectedEuipmentRows] = useState([]);
  const [crewOptions, setCrewOptions] = useState([]);
  const [usersDetails, setUsersDetails] = useState([]);
  const [iscrewLoading, setIscrewLoading] = useState(false);
  const [isprojectLoading, setIsProjectLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [spinnerLoading, setSpinnerLoading] = useState(false);
  const [projectList, setProjectList] = useState([]);
  const [selectedCrew, setSelectedCrew] = useState("");
  const [selectedProject, setSelectedProject] = useState("");
  const [equipmentsDetails, setEquipmentsDetails] = useState([]);
  const [hasCrew, setHasCrew] = useState(false);

  const fetchCrews = async (weekNumber, type) => {
    const query = `week=${weekNumber}`;

    if (type === "allTimesheets") {
      try {
        const crewRes = await getMyTimeSheetDetails(query);
        const filtercrew = crewRes.data.filter(
          (data) => data.time_sheet_status_id === 4
        );
        if (filtercrew?.length > 0) {
          setHasCrew(true);
        } else {
          setHasCrew(false);
        }
      } catch (error) {
        setHasCrew(false);
      }
    } else {
      try {
        setIscrewLoading(true);
        const crewRes = await getMyTimeSheetDetails(query);
        const filtercrew = crewRes.data.filter(
          (data) => data.time_sheet_status_id === 4
        );
        if (filtercrew.length > 0) {
          const crewOptionsArr = filtercrew?.map((crewElement) => ({
            label: crewElement?.crew?.virtual_id,
            value: crewElement?.crew_id,
          }));
          setCrewOptions(crewOptionsArr);
        } else {
          setCrewOptions([]);
        }
      } catch (error) {
      } finally {
        setIscrewLoading(false);
      }
    }
  };
  const handleDownload = async () => {
    const employee_ids = [
      ...new Set(selectedUserRows.map((user) => user.user_id)),
    ];
    const equipment_ids = [
      ...new Set(selectedEuipmentRows.map((user) => user.equipment_id)),
    ];
    const payload = {
      week: getWeekNumber(selectedWeek),
      crew_id: selectedCrew?.value,
      project_id: selectedProject?.value,
      employee_ids: employee_ids,
      equipment_ids: equipment_ids,
    };
    if (
      getWeekNumber(selectedWeek) &&
      selectedCrew?.value &&
      (employee_ids.length || equipment_ids.length)
    ) {
      setSpinnerLoading(true);

      try {
        const response = await downloadCustomerReport(payload);
        if (response.status === 200) {
          setSpinnerLoading(false);
          FileDownload(response?.data, "Customer Report.pdf");
          setSelectedWeek("");
          setSelectedUserRows([]);
          setSelectedEuipmentRows([]);
          setCrewOptions([]);
          setLoading(true);
          setProjectList([]);
          setSelectedCrew("");
          setSelectedProject("");
          setHasCrew(false);
        } else {
          setSpinnerLoading(false);
        }
      } catch (error) {
        setSpinnerLoading(false);
      }
    } else {
      toast.warning("Please fill all the required fields");
    }
  };

  const getTimeSheetWeekDetails = async (timeSheetData) => {
    try {
      setIsProjectLoading(true);
      const userDetailsPromise = getTimeSheetByWeek(timeSheetData, 1).then(
        (res) => res?.data
      );
      const equipmentDetailsPromise = getTimeSheetByWeek(timeSheetData, 2).then(
        (res) => res?.data
      );

      const [userDetails, equipmentDetails] = await Promise.all([
        userDetailsPromise,
        equipmentDetailsPromise,
      ]);

      setUsersDetails(userDetails);
      setEquipmentsDetails(equipmentDetails);

      const combinedData = [...userDetails, ...equipmentDetails];
      const projectOptions = combinedData.map((item) => ({
        label: `(${item.project_number}) ${item.project_name}`,
        value: item.project_id,
      }));

      const uniqueProjectOptions = Array.from(
        new Set(projectOptions.map((option) => option.value))
      ).map((id) => projectOptions.find((option) => option.value === id));

      setProjectList(uniqueProjectOptions);
    } catch (error) {
      console.error("Error fetching timesheet details:", error);
    } finally {
      setIsProjectLoading(false);
    }
  };

  const isSelected = (row, selectedRows) =>
    selectedRows.some(
      (selectedRow) => selectedRow.employee_id === row.employee_id
    );
  const isEquipmentSelected = (row, selectedRows) =>
    selectedRows.some(
      (selectedRow) => selectedRow.equipment_id === row.equipment_id
    );

  const handleRowCheckboxChange = (row, selectedRows, setSelectedRows) => {
    const isRowSelected = isSelected(row, selectedRows);

    if (isRowSelected) {
      setSelectedRows(
        selectedRows.filter(
          (selectedRow) => selectedRow.employee_id !== row.employee_id
        )
      );
    } else {
      setSelectedRows([...selectedRows, row]);
    }
  };
  const handleEuipmentRowCheckboxChange = (
    row,
    selectedRows,
    setSelectedRows
  ) => {
    const isRowSelected = isEquipmentSelected(row, selectedRows);

    if (isRowSelected) {
      setSelectedRows(
        selectedRows.filter(
          (selectedRow) => selectedRow.equipment_id !== row.equipment_id
        )
      );
    } else {
      setSelectedRows([...selectedRows, row]);
    }
  };

  const downloadAll = async () => {
    setSpinnerLoading(true);
    const payload = { week: getWeekNumber(allReportWeek) };
    const res = await downloadAllReport(payload);
    if (res.status === 200) {
      setSpinnerLoading(false);
      FileDownload(res?.data, "Customer Report.zip");
      setAllReportWeek("");
      setHasCrew(false);
    } else {
      setSpinnerLoading(false);
    }
  };

  const onProjectChange = (selectedProject) => {
    setSelectedProject(selectedProject);

    const filteredUsers = selectedProject
      ? usersDetails.filter(
          (user) => user?.project_id === selectedProject?.value
        )
      : usersDetails;

    const uniqueFilteredUsers = Array.from(
      new Set(filteredUsers.map((user) => user.employee_id))
    ).map((id) => filteredUsers.find((user) => user.employee_id === id));

    setSelectedUserRows(uniqueFilteredUsers);
    const filteredEquipment = selectedProject
      ? equipmentsDetails.filter(
          (user) => user?.project_id === selectedProject?.value
        )
      : equipmentsDetails;

    const uniqueFilteredEquipments = Array.from(
      new Set(filteredEquipment.map((user) => user.equipment_id))
    ).map((id) => filteredEquipment.find((user) => user.equipment_id === id));
    setSelectedEuipmentRows(uniqueFilteredEquipments);
    setLoading(false);
  };

  const filteredUsers = selectedProject
    ? usersDetails.filter((user) => user?.project_id === selectedProject?.value)
    : usersDetails;

  const uniqueFilteredUsers = Array.from(
    new Set(filteredUsers?.map((user) => user.employee_id))
  ).map((id) => filteredUsers.find((user) => user.employee_id === id));

  const filteredEquipment = selectedProject
    ? equipmentsDetails.filter(
        (user) => user?.project_id === selectedProject?.value
      )
    : equipmentsDetails;

  const uniqueFilteredEquipments = Array.from(
    new Set(filteredEquipment?.map((user) => user?.equipment_id))
  ).map((id) => filteredEquipment.find((user) => user.equipment_id === id));

  const setWeekData = (data) => {
    const weekNumber = getWeekNumber(data);
    setSelectedWeek(data);
    fetchCrews(weekNumber, "selectedTimsheets");
  };
  const setallReportWeek = (data) => {
    const weekNumber = getWeekNumber(data);
    fetchCrews(weekNumber, "allTimesheets");
    setAllReportWeek(data);
  };

  const onChangeCrew = (item) => {
    setSelectedProject(null);
    setSelectedCrew(item);
    setLoading(true);
    const timeSheetData = {
      week: getWeekNumber(selectedWeek),
      crew_id: item?.value,
    };
    getTimeSheetWeekDetails(timeSheetData);
  };

  return (
    <div className="project-details-page report-page customer-report-page">
      <div className="project-details-toolbar">
        <h1 className="title project-details-title">Customer Report</h1>
      </div>

      <div className="report-cards-row">
      <div className="report-card">
        <h4 className="title project-details-section-title">All Reports</h4>
        <p className="report-card-hint">
          Download the reports of every approved crew for a week in one file
        </p>
        <div className="report-inline-controls">
          <div className="report-field">
            <label className="project-details-field__label">Week</label>
            <DatePicker
              className="form-control report-input"
              placeholderText="Select Week"
              selected={allReportWeek}
              onChange={(date) => {
                setallReportWeek(date);
              }}
              dateFormat="I/R"
              locale="en-gb"
              showWeekNumbers
              showWeekPicker
              onKeyDown={(e) => e.preventDefault()}
            />
          </div>
          <button
            type="button"
            className="primary-btn"
            onClick={downloadAll}
            disabled={!hasCrew}
          >
            Download All Reports
          </button>
        </div>
      </div>

      <div className="report-card">
        <h4 className="title project-details-section-title">Crew Report</h4>
        <p className="report-card-hint">
          Pick a week and a crew, then choose the employees and equipment to
          include below
        </p>
        <div className="report-filter-grid">
          <div className="report-field">
            <label className="project-details-field__label">Week</label>
            <DatePicker
              className="form-control report-input"
              placeholderText="Select Week"
              selected={selectedWeek}
              onChange={(date) => {
                setSelectedCrew(null);
                setSelectedProject(null);
                setLoading(true);
                setWeekData(date);
              }}
              dateFormat="I/R"
              locale="en-gb"
              showWeekNumbers
              showWeekPicker
              onKeyDown={(e) => e.preventDefault()}
            />
          </div>
          <div className="report-field">
            <label className="project-details-field__label">Crew</label>
            <Select
              placeholder="Select Crew"
              value={selectedCrew}
              classNamePrefix="report-select"
              name="colors"
              options={crewOptions}
              onChange={(item) => onChangeCrew(item)}
              isLoading={iscrewLoading}
            />
          </div>
          <div className="report-field">
            <label className="project-details-field__label">Project</label>
            <Select
              value={selectedProject}
              placeholder="Select Project"
              classNamePrefix="report-select"
              name="colors"
              options={projectList}
              onChange={(item) => onProjectChange(item)}
              isLoading={isprojectLoading}
            />
          </div>
        </div>
      </div>
      </div>

      <div className="report-tables">
        <section>
          <div className="report-section-head">
            <h4 className="title project-details-section-title">Employees</h4>
          </div>
          <div className="table-responsive report-table-wrap">
            <table className="table report-table">
              <thead>
                <tr>
                  <th scope="col" className="report-col-select">
                    Select
                  </th>
                  <th scope="col">Employee ID</th>
                  <th scope="col">Name</th>
                </tr>
              </thead>
              <tbody>
                {uniqueFilteredUsers &&
                uniqueFilteredUsers.length > 0 &&
                !loading ? (
                  uniqueFilteredUsers.map((item, key) => (
                    <tr key={key}>
                      <td>
                        <input
                          className="report-checkbox"
                          type="checkbox"
                          checked={isSelected(item, selectedUserRows)}
                          onChange={() =>
                            handleRowCheckboxChange(
                              item,
                              selectedUserRows,
                              setSelectedUserRows
                            )
                          }
                        />
                      </td>
                      <td>{item?.employee_id ? item.employee_id : "NA"}</td>
                      <td>{item?.name}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={3} className="report-empty">
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </section>
        <section>
          <div className="report-section-head">
            <h4 className="title project-details-section-title">Equipment</h4>
          </div>
          <div className="table-responsive report-table-wrap">
            <table className="table report-table">
              <thead>
                <tr>
                  <th scope="col" className="report-col-select">
                    Select
                  </th>
                  <th scope="col">Equipment ID</th>
                  <th scope="col">Name</th>
                </tr>
              </thead>
              <tbody>
                {uniqueFilteredEquipments &&
                uniqueFilteredEquipments.length > 0 &&
                !loading ? (
                  uniqueFilteredEquipments.map((item, key) => (
                    <tr key={key}>
                      <td>
                        <input
                          className="report-checkbox"
                          type="checkbox"
                          checked={isEquipmentSelected(
                            item,
                            selectedEuipmentRows
                          )}
                          onChange={() =>
                            handleEuipmentRowCheckboxChange(
                              item,
                              selectedEuipmentRows,
                              setSelectedEuipmentRows
                            )
                          }
                        />
                      </td>
                      <td>{item?.acumatica_id ? item?.acumatica_id : "NA"}</td>
                      <td>{item?.name}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={3} className="report-empty">
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </section>
      </div>
      <div className="report-actions">
        <button
          type="button"
          className="primary-btn"
          onClick={handleDownload}
        >
          Download Report
        </button>
      </div>
      {spinnerLoading && <Loader />}
    </div>
  );
};

export default CustomerReport;
